import Axios from '../utils/axios-utils';

// create fuel
export const createFuel = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/fuels`, {
            spentBy: data.spentBy,
            vehicleId: data.vehicleId,
            fuelTime: data.fuelTime,
            vendorId: data.vendorId,
            type: data.type,
            quantity: data.quantity,
            odometer: data.odometer,
            amount: data.amount,
            note: data.note
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Fuel error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Fuel failed" }
        };
    }
};

// get all fuels
export const getAllFuels = async (accountId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/fuels`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Fuels error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Fuels failed" }
        };
    }
};

// delete fuel
export const deleteFuel = async (accountId, fuelId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/fuels/${fuelId}`);

        console.log("res : ", response)

        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Fuel error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Fuel failed" },
            status: error.response?.status || 500
        };
    }
};

// update fuel
export const updateFuel = async (accountId, fuelId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/fuels/${fuelId}`, data);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Fuel error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Fuel failed" }
        };
    }
};

// update fuel status
export const updateFuelStatus = async (accountId, fuelId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/fuels/${fuelId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Fuel Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Fuel Status failed" }
        };
    }
};

// get all fuels statuses
export const getAllFuelStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/fuels/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All fuels statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All fuels statuses failed" }
        };
    }
};